module.exports = __webpack_public_path__ + "img/2_ua.34c04cef.jpg";